import React from "react";
import "./DataTable.css";

function DataTable({
    columns,
    rows,
    rowKey = "id",
    onRowClick,
    loading = false,
    empty,
    sticky = true,
    rowClassName,
}) {
    const getKey = (row) =>
        typeof rowKey === "function" ? rowKey(row) : row[rowKey];

    return (
        <div className={`data-table ${sticky ? "data-table--sticky" : ""}`}>
            <div
                className="data-table__head"
                role="row"
                style={{ gridTemplateColumns: gridTemplate(columns) }}
            >
                {columns.map((col) => (
                    <span
                        key={col.key}
                        className={`data-table__cell uppercase-label ${col.className || ""}`}
                        style={{ textAlign: col.align || "left" }}
                    >
                        {col.label}
                    </span>
                ))}
            </div>

            {loading && rows.length === 0 ? (
                <div className="data-table__state mono uppercase-label">Loading…</div>
            ) : rows.length === 0 ? (
                <div className="data-table__empty">{empty || "No results."}</div>
            ) : (
                <div className="data-table__body">
                    {rows.map((row) => {
                        const key = getKey(row);
                        const extra = rowClassName ? rowClassName(row) : "";
                        return (
                            <div
                                key={key}
                                role="row"
                                tabIndex={onRowClick ? 0 : undefined}
                                className={`data-table__row ${onRowClick ? "data-table__row--clickable" : ""} ${extra}`}
                                style={{ gridTemplateColumns: gridTemplate(columns) }}
                                onClick={onRowClick ? () => onRowClick(row) : undefined}
                                onKeyDown={
                                    onRowClick
                                        ? (e) => {
                                              if (e.key === "Enter" || e.key === " ") {
                                                  e.preventDefault();
                                                  onRowClick(row);
                                              }
                                          }
                                        : undefined
                                }
                            >
                                {columns.map((col) => (
                                    <span
                                        key={col.key}
                                        className={`data-table__cell ${col.className || ""}`}
                                        style={{ textAlign: col.align || "left" }}
                                    >
                                        {col.render
                                            ? col.render(row)
                                            : row[col.key] ?? (
                                                  <span className="data-table__empty-val">—</span>
                                              )}
                                    </span>
                                ))}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

function gridTemplate(columns) {
    return columns
        .map((c) => (c.width ? c.width : "minmax(0, 1fr)"))
        .join(" ");
}

export default DataTable;
